import { render, staticRenderFns } from "./RecipeDescription.vue?vue&type=template&id=0544e466&"
import script from "./RecipeDescription.vue?vue&type=script&lang=ts&"
export * from "./RecipeDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports